const MuiDialogActions = {
    root: {
        padding: '0 36px 36px 36px',
        margin: 0,
        justifyContent: 'flext-start',
    },
};

export default MuiDialogActions;
